import * as React from "react";
import { RBACButton } from "../../../molecules/rbac-button";
import { ProcedureEntity } from "../../../../application/domain/procedures/procedure-entity";
import { toast } from "react-toastify";
import { SecondaryButton } from "@graffer-inc/console-design-kit";
import { PublishedUrlCopyButton } from "../../../organisms/smart-apply/procedure-detail/published-url-copy-button";

export const MenuButtons: React.FC<{
  orgSlug: string;
  procedure: ProcedureEntity;
  currentCustomPath?: string;
  onPublishSettingModalOpen: () => void;
  onUnPublish: () => void;
  onPauseAccepting: () => void;
  onReturnToDraft: () => void;
  onResumeAccepting: () => void;
}> = ({
  orgSlug,
  procedure,
  currentCustomPath,
  onPublishSettingModalOpen,
  onUnPublish,
  onReturnToDraft,
  onResumeAccepting,
  onPauseAccepting,
}) => {
  return (
    <div className="buttons has-text-right is-right">
      <PublishedUrlCopyButton
        url={procedure.doorPageURL(orgSlug, currentCustomPath)}
      />
      {procedure.publishStatus === "BEFORE_PUBLISH" && (
        <RBACButton
          target={procedure}
          requirePermissions={"procedures.update"}
          onClick={onReturnToDraft}
          buttonTypes={"secondary"}
          buttonText={"下書きに戻す"}
        />
      )}
      {procedure.publishStatus === "PAUSING_ACCEPT" && (
        <RBACButton
          target={procedure}
          requirePermissions={"procedures.update"}
          onClick={onResumeAccepting}
          buttonTypes={"primary"}
          buttonText={"受付を再開する"}
        />
      )}
      {!procedure.isPublished() && (
        <RBACButton
          target={procedure}
          requirePermissions={"procedures.publish"}
          onClick={() => {
            const msg = procedure.unPublishableError();
            if (!msg) {
              onPublishSettingModalOpen();
            } else {
              toast.error(msg);
            }
          }}
          buttonTypes={"primary"}
          buttonText={"手続きを公開する"}
        />
      )}
      {procedure.isPublished() && !procedure.isArchived() && (
        <SecondaryButton
          text={"公開・受付日時を変更する"}
          onClick={onPublishSettingModalOpen}
        />
      )}
      {procedure.publishStatus === "ACCEPTING" && (
        <SecondaryButton
          text={"受付を一時停止する"}
          onClick={onPauseAccepting}
        />
      )}
      {procedure.isUnPublishable() && (
        <SecondaryButton text={"公開を終了する"} onClick={onUnPublish} />
      )}
    </div>
  );
};
